import A from "../../../@babel/runtime/helpers/esm/extends.js";
import n, { forwardRef as le, useState as y, useRef as h, useCallback as l, useEffect as fe, useMemo as ve, Fragment as me } from "react";
import { p as e } from "../../../prop-types/index.js";
import { FOCUS_DISABLED as be, FOCUS_GROUP as Fe } from "../../../focus-lock/dist/es2015/constants.js";
import { hiddenGuard as _ } from "./FocusGuard.js";
import { mediumFocus as pe, mediumBlur as ye, mediumSidecar as he } from "./medium.js";
import { focusScope as _e } from "./scope.js";
import { useMergeRefs as ge } from "../../../use-callback-ref/dist/es2015/useMergeRef.js";
var Se = [], w = /* @__PURE__ */ le(function(o, j) {
  var f, g = y(), S = g[0], T = g[1], a = h(), i = h(!1), d = h(null), U = y({}), k = U[1], B = o.children, E = o.disabled, t = E === void 0 ? !1 : E, O = o.noFocusGuards, m = O === void 0 ? !1 : O, x = o.persistentFocus, M = x === void 0 ? !1 : x, L = o.crossFrame, V = L === void 0 ? !0 : L, P = o.autoFocus, q = P === void 0 ? !0 : P, z = o.allowTextSelection, H = o.group, J = o.className, K = o.whiteList, Q = o.hasPositiveIndices, C = o.shards, b = C === void 0 ? Se : C, R = o.as, D = R === void 0 ? "div" : R, G = o.lockProps, W = G === void 0 ? {} : G, X = o.sideCar, I = o.returnFocus, v = I === void 0 ? !1 : I, Y = o.focusOptions, F = o.onActivation, p = o.onDeactivation, Z = y({}), ee = Z[0], oe = l(function(r) {
    var c = r.captureFocusRestore;
    if (!d.current) {
      var u, s = (u = document) == null ? void 0 : u.activeElement;
      d.current = s, s !== document.body && (d.current = c(s));
    }
    a.current && F && F(a.current), i.current = !0, k();
  }, [F]), re = l(function() {
    i.current = !1, p && p(a.current), k();
  }, [p]), te = l(function(r) {
    var c = d.current;
    if (c) {
      var u = (typeof c == "function" ? c() : c) || document.body, s = typeof v == "function" ? v(u) : v;
      if (s) {
        var $ = typeof s == "object" ? s : void 0;
        d.current = null, r ? Promise.resolve().then(function() {
          return u.focus($);
        }) : u.focus($);
      }
    }
  }, [v]), ae = l(function(r) {
    i.current && pe.useMedium(r);
  }, []), se = ye.useMedium, ne = l(function(r) {
    a.current !== r && (a.current = r, T(r));
  }, []);
  process.env.NODE_ENV !== "production" && (typeof z < "u" && console.warn("React-Focus-Lock: allowTextSelection is deprecated and enabled by default"), fe(function() {
    !a.current && typeof D != "string" && console.error("FocusLock: could not obtain ref to internal node");
  }, []));
  var ce = A((f = {}, f[be] = t && "disabled", f[Fe] = H, f), W), N = m !== !0, ue = N && m !== "tail", ie = ge([j, ne]), de = ve(function() {
    return {
      observed: a,
      shards: b,
      enabled: !t,
      active: i.current
    };
  }, [t, i.current, b, S]);
  return /* @__PURE__ */ n.createElement(me, null, N && [
    /* @__PURE__ */ n.createElement("div", {
      key: "guard-first",
      "data-focus-guard": !0,
      tabIndex: t ? -1 : 0,
      style: _
    }),
    Q ? /* @__PURE__ */ n.createElement("div", {
      key: "guard-nearest",
      "data-focus-guard": !0,
      tabIndex: t ? -1 : 1,
      style: _
    }) : null
  ], !t && /* @__PURE__ */ n.createElement(X, {
    id: ee,
    sideCar: he,
    observed: S,
    disabled: t,
    persistentFocus: M,
    crossFrame: V,
    autoFocus: q,
    whiteList: K,
    shards: b,
    onActivation: oe,
    onDeactivation: re,
    returnFocus: te,
    focusOptions: Y,
    noFocusGuards: m
  }), /* @__PURE__ */ n.createElement(D, A({
    ref: ie
  }, ce, {
    className: J,
    onBlur: se,
    onFocus: ae
  }), /* @__PURE__ */ n.createElement(_e.Provider, {
    value: de
  }, B)), ue && /* @__PURE__ */ n.createElement("div", {
    "data-focus-guard": !0,
    tabIndex: t ? -1 : 0,
    style: _
  }));
});
w.propTypes = process.env.NODE_ENV !== "production" ? {
  children: e.node,
  disabled: e.bool,
  returnFocus: e.oneOfType([e.bool, e.object, e.func]),
  focusOptions: e.object,
  noFocusGuards: e.bool,
  hasPositiveIndices: e.bool,
  allowTextSelection: e.bool,
  autoFocus: e.bool,
  persistentFocus: e.bool,
  crossFrame: e.bool,
  group: e.string,
  className: e.string,
  whiteList: e.func,
  shards: e.arrayOf(e.any),
  as: e.oneOfType([e.string, e.func, e.object]),
  lockProps: e.object,
  onActivation: e.func,
  onDeactivation: e.func,
  sideCar: e.any.isRequired
} : {};
const Ge = w;
export {
  Ge as default
};
